import dayjs from "dayjs";
import duration from 'dayjs/plugin/duration';

export const timestampToWeekday = (timestamp) => {
  return dayjs.unix(timestamp).format("dddd");
};

export const timestampToDate = (timestamp) => {
  const currentTimestamp = dayjs();
  const unixDate = dayjs.unix(timestamp);

  if (currentTimestamp.diff(unixDate) > 0 && !currentTimestamp.isSame(unixDate, "day")) {
    return unixDate.format("DD MMMM YYYY");
  }

  if (currentTimestamp.diff(unixDate, "hour", true) >= 1.5) {
    return unixDate.format("HH:mm");
  }

  return dayjs().to(unixDate);
};

export const simpleDateFromTimestamp = (timestamp) => {
  return dayjs.unix(timestamp).format("DD.MM.YYYY");
};

export const getTimeLeft = (targetTimestamp) => {
  dayjs.extend(duration);
  const now = dayjs();
  const target = dayjs(targetTimestamp);

  const diffMs = target.diff(now);
  if (diffMs <= 0) {
    return '';
  }
  const dur = dayjs.duration(diffMs);
  const days = Math.floor(dur.asDays());
  const hours = dur.hours();
  const minutes = dur.minutes();
  const seconds = dur.seconds();

  if (days > 0) {
    return `${days}d : ${hours}h : ${minutes}min : ${seconds}s`;
  }

  if (hours > 0) {
    return `${hours}h : ${minutes}min : ${seconds}s`;
  }

  return `${minutes}min : ${seconds}s`;
}
